const initialState = {
  trendMetricConfigs: [],
};

export const metricConfigs = (state = initialState, action) => {
  switch (action.type) {
    // app/services/initialization_data_service.rb
    case 'INITIALIZATION_DATA': {
      return {
        ...state,
        trendMetricConfigs: action.data.trendMetricConfigs,
      };
    }
    default: {
      return state;
    }
  }
};
